import { eUnderwriter } from '../../../ui-toolkit/enums/eUnderwriter';
import { convertNullToUndefined } from '../../../ui-toolkit/utilities/convertNullToUndefined';
import { eUSAState } from '../../../ui-toolkit/enums/states';

export interface IUnderwriterProfileSummaryResponse {
  effectiveDate: string;
  state: eUSAState;
  underwriter?: eUnderwriter;
  zone?: string;
}

export interface IUnderwriterProfileSummaryData {
  effectiveDate: string;
  state: eUSAState;
  underwriter?: eUnderwriter;
  zone?: string;
}
export const convertIUnderwriterProfileSummaryResponseToIUnderwriterProfileSummaryData = ({
  underwriter,
  zone,
  ...rest
}: IUnderwriterProfileSummaryResponse): IUnderwriterProfileSummaryData => ({
  underwriter: convertNullToUndefined<eUnderwriter>(underwriter),
  zone: convertNullToUndefined<string>(zone),
  ...rest,
});
